<template>
  <div>
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <aside class="app-sidebar">
      <div class="app-sidebar__user">
        <div style="margin:auto">
          <img class="sidebar-logo2" src="/images/l4-temp3.png" />
        </div>
      </div>
      <ul v-if="admin_token" class="app-menu">
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="yeoSahalar" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/data.svg" />
            <span class="app-menu__label">YEO SAHALAR</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="yeomakineler" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/ad1.svg" />
            <span class="app-menu__label">YEO MAKİNELER</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="yeomakinegider" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/ad1.svg" />
            <span class="app-menu__label">YEO GİDERLER</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="yeocomplatesaha" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/data.svg" />
            <span class="app-menu__label">YEO BİTEN SAHALAR</span>
          </router-link>
        </li>
      </ul>
      <ul @click="checkSecurity()" v-if="token" class="app-menu">
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="notes" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/data.svg" />
            <span class="app-menu__label">Sahalar Ve Veriler</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="complatesaha" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/data2.svg" />
            <span class="app-menu__label">Onaylanacak Sahalar</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="complatesahatwo" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/data3.svg" />
            <span class="app-menu__label">Onaylanan Sahalar</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="complatefullsaha" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/data4.svg" />
            <span class="app-menu__label">Kapanan Sahalar</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="notifications" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/tList.svg" />
            <span class="app-menu__label">Yapılacaklar </span>
          </router-link>
        </li>
        <li v-if="id==45 || id==43 || id==41" class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="bankchecks" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/tList.svg" />
            <span class="app-menu__label"> Finans Ekranı </span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2 hover-div2">
          <router-link class="app-menu__item" to="uploadFile" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/sunny_fields2.svg" />
            <span class="app-menu__label">Saha Kayıt Ekranı</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="sahaguncelleme" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/Machine.svg" />
            <span class="app-menu__label">Saha Güncelleme </span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="raporkayit" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/reportadd.svg" />
            <span class="app-menu__label">Rapor Kayıt </span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="aslanmakineler" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/ad1.svg" />
            <span class="app-menu__label">Raporlama Ekranı</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="raporguncelleme" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/refresh.svg" />
            <span class="app-menu__label">Rapor Güncelleme </span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="personelekle" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/ad1.svg" />
            <span class="app-menu__label">Personel Ekleme </span>
          </router-link>
        </li>

        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="students" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/giderrenk.svg" />
            <span class="app-menu__label">Saha Giderleri</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="giderkayit" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/dollar22.svg" />
            <span class="app-menu__label">Saha Gider Kayıt</span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="stokkayit" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/bit2.svg" />
            <span class="app-menu__label">Stok Kayıt</span>
          </router-link>
        </li>
        <!-- <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="updatemakine" tag="a">
            <img
              class="app-menu__icon fa fa-file-text"
              src="/images/sahagider.svg"
            />
            <span class="app-menu__label">Makine Güncelleme </span>
          </router-link>
        </li> -->
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="makinefiltre" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/makine6.svg" />
            <span class="app-menu__label">Makine Filtreleme </span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="personelfiltre" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/makine6.svg" />
            <span class="app-menu__label">Personel Filtreleme </span>
          </router-link>
        </li>
        <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="nakliyefiltre" tag="a">
            <img class="app-menu__icon fa fa-file-text" src="/images/nakliye.svg" />
            <span class="app-menu__label">Nakliye Filtreleme </span>
          </router-link>
        </li>
        <!-- <li class="treeview refresh hover-div2">
          <router-link class="app-menu__item" to="personelbakiye" tag="a">
            <img
              class="app-menu__icon fa fa-file-text"
              src="/images/sahagider.svg"
            />
            <span class="app-menu__label">Personel Bakiye </span>
          </router-link>
        </li> -->

      </ul>
    </aside>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      token: null,
      admin_token: "",
      token: "",
      id: "",
    };
  },
  methods: {
    lockScreen() {
      this.$store.dispatch("lockScreen");
    },
    checkSecurity() {
      this.token = localStorage.getItem("token");
      this.admin_token = localStorage.getItem("admin_token");
      this.id = localStorage.getItem("id");

      var datas = {
        id: this.id,
        admin_token: this.admin_token,
        token: this.token,
      };
      var url = "https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/checkSecurity.php?key=123";
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          // console.log(response.data.email)
          if (response.data.email) {
            console.log("successSecurity")
          } else {
            alert("Yetkisiz İşlem Yapılmaya Çalışıldı Giriş Sayfasına Yönlendirileceksiniz")
            this.$store.dispatch("logout");
          }
          // console.log(response);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    checkSecurityAdmin() {
      this.token = localStorage.getItem("token");
      this.admin_token = localStorage.getItem("admin_token");
      this.id = localStorage.getItem("id");

      var datas = {
        id: this.id,
        admin_token: this.admin_token,
        token: this.token,
      };
      var url = "https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/checkSecurityAdmin.php?key=123";
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          //    console.log("response.data.data")
          if (response.data.data.email) {
            console.log("true")
          } else {
            alert("Yetkisiz İşlem Yapılmaya Çalışıldı Giriş Sayfasına Yönlendirileceksiniz")
            this.$store.dispatch("logout");
          }

        })
        .catch((err) => {
          console.log(err.response);
        });
    },
  },
  mounted() {
    this.admin_token = localStorage.getItem("admin_token");
    this.token = localStorage.getItem("token");
    this.id = localStorage.getItem("id");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/default/Sidebar.vue